import { INTERACTION_STUDIO_EVENT_ACTION } from 'constants/analytics'
import { touch } from 'api/interactionStudio'
import { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'

const filterToActionMapping: Record<string, string> = {
  capacity: INTERACTION_STUDIO_EVENT_ACTION.SelectTravellers,
  checkin: INTERACTION_STUDIO_EVENT_ACTION.SelectDates,
}

export function interactionStudioAPIController(filter: OfferPageFilterType, interactionStudioData?: App.ISACheckoutData) {
  const action = filterToActionMapping[filter]
  return action ? touch(interactionStudioData, action) : null
}
